import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EvCore } from 'ev-core';
import { SaleInArea } from 'src/models/estate/IResidenceSaleInArea';

@Component({
  selector: 'estate-map-marker',
  imports: [CommonModule, EvCore],
  templateUrl: './estate-map-marker.component.html',
  styleUrl: './estate-map-marker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstateMapMarkerComponent {
    data = input<SaleInArea>();
    // Kept as the template's accessor; now backed directly by the input signal.
    componentData = this.data;
    validArea = computed(() => this.componentData()?.residentialMeasuredArea);
    price = computed(() =>
        this.componentData()?.price > 0 ? this.componentData().price : this.componentData()?.priceExcludingCommonDebt > 0 ? this.componentData().priceExcludingCommonDebt : null
    );
}
